import React from 'react';
import { useTranslation } from 'react-i18next';
import InformationOverlay from '../../../../../components/InformationOverlay';

import './style.scss';

/**
 * Participants Section Component
 *
 * Displays the "Deelnemers" (Participants) section with:
 * - Section title with info overlay
 * - Banner informing users that they can assign seats later
 *
 * Shown when:
 * - User checks "order for someone else" checkbox
 * - Cart quantity is 2 or more
 *
 * @component
 */

const ParticipantsBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <fieldset className="ParticipantsSection">
      <legend className="ParticipantsSection__legend">
        {t('checkout.participants_section_title')}
        <InformationOverlay
          overlayKey="FieldsetOverlay__participants"
          title={t('checkout.participants_overlay_title')}
          body={t('checkout.participants_overlay_body')}
        />
      </legend>
      <div className="ParticipantsBanner">
        <p className="ParticipantsBanner__text">
          {t('checkout.participants_banner_message')}
        </p>
      </div>
    </fieldset>
  );
};

export default ParticipantsBanner;
